export default "__VITE_ASSET__D6N8D7gb__"